export default __webpack_public_path__ + "static/media/c-dislike-icon.ca91eac1.svg";